<template>
  <div class="getFreePopu">
      <el-dialog title="免费获取" width="500px" :visible.sync="status" :before-close="closeDialog">
          <div class="content">
              <p class="msg">请填写以下信息，即可下载免费报告。</p>

            <el-form ref="ruleForm" :model="api" label-width="80px" align="left" :rules="rules">
                <el-form-item label="公司名称：" prop="companyname">
                    <el-input style="width: 380px" placeholder="请填写正确的公司名称" v-model="api.companyname"></el-input>
                </el-form-item>
                <el-form-item label="联系人：" prop="linkman">
                    <el-input style="width: 380px" placeholder="请填写联系人" v-model="api.linkman"></el-input>
                </el-form-item>
                <el-form-item label="联系电话：" prop="linktel">
                    <el-input style="width: 380px" placeholder="请填写联系电话" v-model="api.linktel"></el-input>
                </el-form-item>
                <el-form-item label="职位：" prop="linkduty">
                    <el-input style="width: 380px" placeholder="请填写您的职位" v-model="api.linkduty"></el-input>
                </el-form-item>
                <el-form-item label="验证码：" prop="usercode">
                    <el-input style="width: 260px" placeholder="请输入验证码" v-model="api.usercode" maxlength="4"></el-input>
                    <img @click="getCode" :src="base64"/>
                </el-form-item>
            </el-form>
              <input style="width:0;height:0;border:none"/>
            <el-button type="primary" @click="submit('ruleForm')">免费获取</el-button>   
         </div>
      </el-dialog>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {createCode, dealSwEvOrderinfo} from 'api/gujingApi'
export default {
  name: 'getFreePopu',
  data () {
    var justCompanyname = (rule, value, callback) => {
        if (!value) {
            return callback(new Error('公司名称不能为空'))
        }
        callback()
    }
    var justLinktel = (rule, value, callback) => {
        if (!value) {
            return callback(new Error('联系电话不能为空'))
        } else {
            if (!(/^1[3456789]\d{9}$/.test(this.api.linktel))) {
                return callback(new Error('请输入正确的联系电话格式'))
            }
        }
        callback()
    }
    var justLinkman = (rule, value, callback) => {
        if (!value) {
            return callback(new Error('联系人不能为空'))
        }
        callback()
    }
    var justLinkduty = (rule, value, callback) => {
        if (!value) {
            return callback(new Error('职位不能为空'))
        }
        callback()
    }
    var justUsercode = (rule, value, callback) => {
        if (!value) {
            return callback(new Error('验证码不能为空'))
        }
        callback()
    }
    return {
        status: false,
        api: {
            orderno: '', // 订单号
            companyname: '',   // 企业名称
            linkman: '', // 称呼
            linktel: '', // 联系方式
            linkduty: '', // 联系人职位
            usercode: '', // (用户输入的验证码)
            codeEncryption: ''  // 加密后的验证码
            // clienttype: 1
        },
        base64: '',
        page: '',
        rules: {
            companyname: [
                {validator: justCompanyname, trigger: 'blur'}
            ],
            linkman: [
                {validator: justLinkman, trigger: 'blur'}
            ],
            linktel: [
                {validator: justLinktel, trigger: 'blur'}
            ],
            linkduty: [
                {validator: justLinkduty, trigger: 'blur'}
            ],
            usercode: [
                {validator: justUsercode, trigger: 'blur'}
            ]
        }
    }
  },
  mounted () {
    //   this.getCode()
  },
  methods: {
      startDialog(orderno, page) {   // 开启弹窗
          this.getCode()
          this.status = true
          this.api.orderno = orderno
          this.page = page
      },
      closeDialog() {   // 弹窗关闭
        this.status = false
      },
      getCode() {
          this.setLoading(true)
          createCode({
              data: {},
              success: data => {
                   this.setLoading(false)
                   this.base64 = data.result.base64
                   this.api.codeEncryption = data.result.codeEncryption
              },
              error: data => {
                  this.setLoading(false)
                  this.$message.error(data.msg)
              }
          })
      },
      submit(formName) {
        this.$refs[formName].validate((valid) => {
            if (valid) {
                this.setLoading(true)
                dealSwEvOrderinfo({
                    data: this.api,
                    success: data => {
                        this.setLoading(false)
                        if (data.code == '000') {
                            //刷新列表
                            this.$parent.justList(this.page)
                            this.downloadPdf(data.data.evreporturl, '企业估值报告')
                            this.closeDialog()
                        } else {
                            this.$message.error(data.msg)
                        }
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            } else {
                return false
            }
        })
      },
      // 下载文件
      downloadPdf(url, name) {
            this.setLoading(true)
            fetch(url).then(res => res.blob()).then(blob => {
                // console.log(blob)
                const a = document.createElement('a')
                document.body.appendChild(a)
                a.style.display = 'none'
                // 使用获取到的blob对象创建的url
                const url = window.URL.createObjectURL(blob)
                a.href = url
                // 指定下载的文件名
                a.download = name
                this.setLoading(false)
                this.dialogVisible = false
                a.click()
                document.body.removeChild(a)
                // 移除blob对象的url
                window.URL.revokeObjectURL(url)
            })
        },
      ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss">
.getFreePopu {
 .content {
        // height: 120px;
        text-align: center;
        .msg {
            color: #666;
            font-size: 14px;
            text-align: left;
        }
        img {
            cursor: pointer;
            float: right;
        }
        // .input {
        //     margin-top: 20px;
        //     height: 40px;
        //     text-align: left;
        //     .name {
        //         float: left;
        //         display: block;
        //         width: 80px;
        //         text-align: left;
        //         line-height: 40px;
        //     }
        // }
        .el-form {
             margin-top: 20px;
            .el-form-item__label {
                text-align: left;
                padding-right: 0;
            }
        }
        .el-button {
            margin-top: 40px;
            width: 280px;
        }
    }
}
</style>